import _ from '../../core/utils'
import SLIDER_MORE_CONFIG from "./config"
import Flickity from 'flickity'

class SliderMoreClass {
    constructor( slider ) {
        this.DOM = {
            slider: slider,
            slides: _.selectAll( '.slide', slider )
        }

        this.flckty = null
        this.slidesLength = this.DOM.slides.lenght

        this.init()
    }

    init() {
        this._slider()
    }

    _slider() {
        this.flckty = new Flickity( this.DOM.slider, {
            pageDots: false,
            prevNextButtons: false,
            contain: true,
            wrapAround: true,
            cellAlign: 'left',
            on: {
                ready: () => {
                    this._cardHeight()
                }
            }
        })
    }

    _cardHeight() {
        this.DOM.slides.forEach( ( slide ) => {
            let card = _.select( '.fl__card', slide )
            card.style.height = `${slide.clientHeight}px`
        })
    }
}

const SLIDERS_MORE = []
SLIDER_MORE_CONFIG.sliders.forEach( ( slider ) => {
    SLIDERS_MORE.push( new SliderMoreClass( slider ) )
})